import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const NAV_ITEMS = [
  { label: '首页', to: '/' },
  { label: '资讯', to: '/news' },
  { label: '剧情', to: '/category/plot' },
  { label: '专题', to: '/category/feature' },
  { label: '关于', to: '/about' },
];

export default function SiteHeader() {
  const location = useLocation();
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
    setKeyword('');
    setMenuOpen(false);
  };

  const isActive = (to: string) => {
    if (to === '/') return location.pathname === '/';
    return location.pathname.startsWith(to.split('/').slice(0, 2).join('/'));
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled ? 'bg-primary-900/95 backdrop-blur ' : 'bg-primary-900'
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="mx-auto flex h-16 md:h-20 max-w-[1280px] items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-3 shrink-0">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-background-50">
              <i className="ri-movie-2-line text-xl"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg md:text-xl font-bold tracking-tight text-background-50">
                疯狂试爱<span className="text-accent-400">2</span>
              </span>
              <span className="mt-1 hidden text-[11px] tracking-[0.2em] text-primary-200 sm:block">
                FILM CONTENT HUB
              </span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-colors ${
                  isActive(item.to)
                    ? 'bg-primary-700 text-background-50'
                    : 'text-primary-100 hover:bg-primary-800 hover:text-background-50'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <form onSubmit={handleSearch} className="hidden md:flex items-center">
              <div className="relative">
                <i className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-base text-primary-200"></i>
                <input
                  type="text"
                  name="q"
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder="搜索影视资讯 / 剧情"
                  className="h-10 w-40 lg:w-56 rounded-md border border-primary-700 bg-primary-800 pl-9 pr-3 text-sm text-background-50 placeholder:text-primary-300 outline-none transition-all focus:w-64 focus:border-accent-400"
                />
              </div>
              <button
                type="submit"
                className="ml-2 h-10 whitespace-nowrap rounded-md bg-accent-500 px-4 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600 cursor-pointer"
              >
                搜索
              </button>
            </form>

            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setMenuOpen((v) => !v)}
              className="flex h-10 w-10 items-center justify-center rounded-md text-background-50 transition-colors hover:bg-primary-800 md:hidden cursor-pointer"
            >
              <i className={menuOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-primary-800 bg-primary-900 md:hidden">
          <div className="px-4 py-4">
            <form onSubmit={handleSearch} className="mb-4 flex flex-col gap-2">
              <div className="relative w-full">
                <i className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-base text-primary-200"></i>
                <input
                  type="text"
                  name="q"
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder="搜索影视资讯 / 剧情"
                  className="h-11 w-full rounded-md border border-primary-700 bg-primary-800 pl-10 pr-3 text-sm text-background-50 placeholder:text-primary-300 outline-none focus:border-accent-400"
                />
              </div>
              <button
                type="submit"
                className="h-11 w-full whitespace-nowrap rounded-md bg-accent-500 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600 cursor-pointer"
              >
                搜索
              </button>
            </form>
            <nav className="flex flex-col gap-1">
              {NAV_ITEMS.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`rounded-md px-4 py-3 text-sm font-medium transition-colors ${
                    isActive(item.to)
                      ? 'bg-primary-700 text-background-50'
                      : 'text-primary-100 hover:bg-primary-800'
                  }`}
                >
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}